import React from "react";

const DeleteJobCardModal = ({ show, onClose, onConfirm, jobCard }) => {
    if (!show || !jobCard) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-md">
                <h2 className="text-xl font-semibold text-gray-800 mb-4">Confirm Delete</h2>
                <p className="text-gray-600 mb-6">
                    Are you sure you want to delete job card with ID <strong>{jobCard.id}</strong>?
                </p>
                <div className="flex justify-end gap-3">
                    <button
                        className="px-4 py-2 rounded bg-gray-300 hover:bg-gray-400 transition"
                        onClick={onClose}
                    >
                        Cancel
                    </button>
                    <button
                        className="px-4 py-2 rounded bg-red-500 text-white hover:bg-red-600 transition"
                        onClick={() => onConfirm(jobCard.id)}
                    >
                        Delete
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeleteJobCardModal;
